module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mKbAlG/tc-custom/9781617456091.jpg?1706124140843",
      "alt": "This image is the cover for the book Magical Unicorn Quilt"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Magical Unicorn Quilt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The bestselling Piece O’ Cake Designs author helps you capture the magic of this mythical creature with colorful and versatile full-size patterns. ")]), _c('br'), _c('br'), _vm._v("Let your creativity run wild with this totally adorable, rainbow-colored quilt to appliqué. With two sizes of unicorn blocks (35” x 35” and 50” x 50”) and 5 sizes of quilts (wall, crib, twin, throw, and queen), you’ll be able to make an enchanting quilt for all the unicorn lovers in your life, large or small! Includes instructions for both needle-turn appliqué and machine appliqué, as well as finishing techniques. This quilt will be a galloping success as the perfect gift for baby showers, birthdays, and other special occasions.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Becky Goldsmith\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Becky Goldsmith Bio: Becky Goldsmith is the co-owner of Piece O’ Cake Designs quilt patterns, as well as an award-winning quilter. Her art background and interior design degree provide a perfect alliance of insight and experience for quilting. She lives in Sherman, Texas. pieceocake.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing, Inc\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0